import { useMutation, useRequest, useModel, useLocation } from "@umijs/max";
import React, { useState, useEffect } from 'react';
import { getMarketingCalendarList, http_day_info, adhesiveBandageGenerateAnImage, selectTaskImageLists } from "../services/MarketingCalendar";
import {
    hotserBuildAScenario,
    dataBuildAScenario,
    getHotspotSchemeImage
} from '@/services/PublicApi';
import {useProgramme} from '@/hooks/useProgramme'
import {planDetailsState} from '@/states/planpage';
import publicApi from '@/models/publicApi';
import { message } from "antd";

let clareImage: any = null;

const marketingCalendar = () => {
    const controller = new AbortController();

    const {
        handleDataGenerateAnalysisResults,
        handleHotspotGenerateAnalysisResults,
    } = useModel('publicApi');
    const {handle_programme} = useProgramme();
    const [calendarList, setCalendarList] = useState<any>([]);
    const [isSelectTaskImageLists, setIsSelectTaskImageLists] = useState<any>(false); // 生成图片时 禁用
    const [isPlanInfo, setIsPlanInfo] = useState<any>(false);
    const [activeFrom, setActiveFrom] = useState<any>({ hotspotSchemeImageInfoList: [] }); //选中方案
    const [withPictures, setWithPictures] = useState<any>([]);


    // 状态数据流
    const [loading, setLoading] = useState(false);
    // 分析结果
    const [analysisLoading, setAnalysisLoading] = useState(false); // 分析结果loading
    const [creativeProposal, setCreativeProposal] = useState<any>([]);


    const { mutate: getCalendarListData, isLoading: isCalendarListLoading } = useMutation(getMarketingCalendarList, {
        onSuccess: (data, variables, context) => {
            if (data && Array.isArray(data.payload) && data.payload.length > 0) {
                setCalendarList(data.payload)
            } else {
                setCalendarList([]);
                // message.success("数据加载失败")
            }
        }
    })
    

    // 热点方案上传
    const { loading: hotSerBuildAScenarioLoading, data: hotSerBuildAScenarioData, run: handleHotSerBuildAScenario, cancel: handleHotSerBuildAScenarioCancel } =
        useRequest(async (data, readOnly) => {
            if(clareImage) {
                planDetailsState.programmeTotal = 1;
                handleHotProgrammeImagesCancel();
            }
            const result = await hotserBuildAScenario(data, controller.signal);
            if (result.status === 0) {
                planDetailsState.informationLoading = false;
                planDetailsState.loading = false;
                // planDetailsState.analysisLoading = true;
                let channelIds: any = [];
                result.payload.map((item: any) => {
                    channelIds.push(item.id);
                });
                planDetailsState.creativeProposalList = handle_programme(result.payload, data.assistantId);
                planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any, index: number) => {
                    return {
                        ...item,
                        active: index === 0? true : false,
                        hotspotSchemeImageInfoList: []
                    }
                });
                
                if (channelIds.length > 0) {
                    handleHotProgrammeImages({ channelId: channelIds.join(',') });
                }
                if (planDetailsState.creativeProposalList.length > 0) {
                  planDetailsState.activeFrom = planDetailsState.creativeProposalList[0];
                }
                let marketingCalendarState: any = JSON.parse(localStorage.getItem('marketingCalendar'));
                marketingCalendarState.data.schemeLists = planDetailsState.creativeProposalList;
                localStorage.setItem('marketingCalendar',JSON.stringify(marketingCalendarState));
                if (Array.isArray(result.payload) && result.payload.length > 0) {
                    let obj = {
                      sourceId: marketingCalendarState.data.dataId,
                      parameterId: result.payload[0].parameterId,
                      assistantId: data.assistantId,
                      productsName: marketingCalendarState.data.productsName,
                      brandName: marketingCalendarState.data.brandName,
                      productsId: marketingCalendarState.data.productsId,
                      brandId: marketingCalendarState.data.brandId,
                    }
                    handleHotspotGenerateAnalysisResults(obj);
                  }
            } else {
                planDetailsState.creativeProposalList = [];
                planDetailsState.informationLoading = false;
                planDetailsState.loading = false;
            }
            return result.payload;
        }, {
            manual: true,
        });
    // 日历
    const { loading: dataBuildAScenarioLoading, data: dataBuildAScenarioData, run: handleDataBuildAScenario } =
        useRequest(async (data, readOnly) => {
            if(clareImage) {
                planDetailsState.programmeTotal = 1;
                handleHotProgrammeImagesCancel();
            }
            const result = await dataBuildAScenario(data, controller.signal);
            if (result.status === 0) {
                planDetailsState.informationLoading = false;
                planDetailsState.loading = false;
                // planDetailsState.analysisLoading = true;
                let channelIds: any = [];
                result.payload.map((item: any) => {
                    channelIds.push(item.id);
                });
                planDetailsState.creativeProposalList = handle_programme(result.payload, data.assistantId);
                planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any, index: number) => {
                    return {
                        ...item,
                        active: index === 0? true : false,
                        hotspotSchemeImageInfoList: []
                    }
                });
                let marketingCalendarState: any = JSON.parse(localStorage.getItem('marketingCalendar'));
                marketingCalendarState.data.schemeLists = planDetailsState.creativeProposalList;
                localStorage.setItem('marketingCalendar',JSON.stringify(marketingCalendarState));
                // 方案生成成功后 请求对应图片
                if (channelIds.length > 0 && !(channelIds.length == 1 && result.payload[0].socialmedia == "直播文案")) {
                    handleHotProgrammeImages({ channelId: channelIds.join(',') });
                }
                if (planDetailsState.creativeProposalList.length > 0) {
                  planDetailsState.activeFrom = planDetailsState.creativeProposalList[0];
                }
                if (result.payload && result.payload.length > 0) {
                    let obj = {
                      sourceId: marketingCalendarState.data.dataId,
                      parameterId: result.payload[0].parameterId,
                      assistantId: data.assistantId,
                      productsName: marketingCalendarState.data.productsName,
                      brandName: marketingCalendarState.data.brandName,
                      productsId: marketingCalendarState.data.productsId,
                      brandId: marketingCalendarState.data.brandId,
                    }
                    localStorage.setItem('marketingCalendar', JSON.stringify({
                        ...marketingCalendarState,
                        data: {
                            ...marketingCalendarState.data,
                            parameterId: result.payload[0].parameterId,
                        }
                    }));
                    handleDataGenerateAnalysisResults(obj)
                }
            } else {
                planDetailsState.creativeProposalList = [];
                planDetailsState.informationLoading = false;
                planDetailsState.loading = false;
                planDetailsState.schemeState = 3;
            }
            return result.payload;
        }, {
            manual: true,
            onError: (error: any) => {
                planDetailsState.creativeProposalList = [];
                planDetailsState.informationLoading = false;
                planDetailsState.loading = false;
                planDetailsState.schemeState = 3;
            }
        });
    const handleDataBuildAScenarioCancel = () => {
        controller.abort();
    }
    const controllerHotProgrammeImages = new AbortController();
    
    // 请求图 af 生成方案后请求对应方案的图片
    const { loading: hotProgrammeImagesLoading, data: hotProgrammeImagesData, run: handleHotProgrammeImages} =
        useRequest(async (data) => {
            const result = await getHotspotSchemeImage(data, controllerHotProgrammeImages.signal);
            let total = 1;
            if (result.payload && result.payload.hotSpotSchemeDetailImageInfo && result.payload.hotSpotSchemeDetailImageInfo.length > 0) {
                planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any) => {
                    let flag = result.payload.hotSpotSchemeDetailImageInfo.find((i: any) => i.id === item.id);
                    if (flag) {
                        Object.assign(item, {
                            isFinish: result.payload.isFinish || false,
                            hotspotSchemeImageInfoList: result.payload.isFinish ? flag.hotspotSchemeImageInfoList : flag.hotspotSchemeImageInfoList.slice(0, -1)
                        });
                    }
                    return item;
                });
                if(!result.payload.isFinish) {
                    if (planDetailsState.programmeTotal <= 9 && (location.pathname.includes('planDetails') || location.pathname.includes('planPageInfo') || location.pathname.includes('hotCreativePlan') || location.pathname.includes('customCreativePlan'))) {
                        planDetailsState.programmeTotal = planDetailsState.programmeTotal + 1;
                        clareImage = setTimeout(() => {
                            clearTimeout(clareImage);
                            handleHotProgrammeImages(data);
                        }, 4000);
                    } else {
                        planDetailsState.programmeTotal = 1;
                        handleHotProgrammeImagesCancel();
                    }
                }
                else {
                    handleHotProgrammeImagesCancel();
                }
                let marketingCalendarState: any = JSON.parse(localStorage.getItem('marketingCalendar'));
                marketingCalendarState.data.schemeLists = planDetailsState.creativeProposalList;
                localStorage.setItem('marketingCalendar',JSON.stringify(marketingCalendarState));
            } else {
              if (planDetailsState.programmeTotal <= 9 && (location.pathname.includes('planDetails') || location.pathname.includes('planPageInfo') || location.pathname.includes('hotCreativePlan') || location.pathname.includes('customCreativePlan'))) {
                planDetailsState.creativeProposalList = planDetailsState.creativeProposalList.map((item: any) => {
                    return {
                        ...item,
                        isFinish: false
                    };
                });
                planDetailsState.programmeTotal = planDetailsState.programmeTotal + 1;
                clareImage = setTimeout(() => {
                  clearTimeout(clareImage);
                  handleHotProgrammeImages(data);
                }, 4000)
              } else {
                planDetailsState.programmeTotal = 1;
                handleHotProgrammeImagesCancel();
              }
            }
            
            return result
        }, {
        manual: true,
        pollingWhenHidden: false,
    });
    // 清除请求图 af 生成方案后 取消请求，清除定时器
    const handleHotProgrammeImagesCancel = () => {
        clearTimeout(clareImage);
        controllerHotProgrammeImages.abort();
    }

    // 日历  今日详情
    const { loading: dayInfoLoading, data: dayInfoData, run: handleDayInfo, cancel: handleDayInfoCancel } =
        useRequest(async (data) => {
            const result = await http_day_info(data);
            let obj: any = {};
            if (result.status === 0) {
                obj = result.payload
            } else {
                obj = {}
            }
            return obj
        }, {
            manual: true,
        });

    // 生成画面
    const { loading: bandageGenerateInfoLoading, data: bandageGenerateAnImageData, run: handleBandageGenerateAnImage } =
        useRequest(async (data) => {
            const result = await adhesiveBandageGenerateAnImage(data);
            // 带双引号的数据为固定值需要找到对应的id替换上去就可以了
            setIsSelectTaskImageLists(true);
            handleSelectTaskImageLists({
                taskIds: result.payload
            })
            return result
        }, {
            manual: true,
            throttleInterval: 1000,
        });

    // 生成画面的图片
    const { loading: selectTaskImageListsLoading, data: selectTaskImageListsData, run: handleSelectTaskImageLists, cancel: handleSelectTaskImageListsCancel } =
        useRequest(async (data) => {
            const result = await selectTaskImageLists(data);
            let total = 1;
            if (result.payload && result.payload.length > 0) {
                handleSelectTaskImageListsCancel()
                setIsSelectTaskImageLists(false);
                planDetailsState.generateTotal = 1;
                planDetailsState.generateImages = result.payload;
                setWithPictures(result.payload)
            } else {
                if (planDetailsState.generateTotal <= 9) {
                    planDetailsState.generateTotal = planDetailsState.generateTotal + 1;
                    let clare = setTimeout(() => {
                        clearTimeout(clare);
                        handleSelectTaskImageLists(data);
                    }, 3000)
                } else {
                    setIsSelectTaskImageLists(false);
                    planDetailsState.generateTotal = 1;
                    handleSelectTaskImageListsCancel();
                }
            }
            return result
        }, {
            manual: true,
            pollingWhenHidden: false,
        });



    return {
        loading,
        setLoading,
        analysisLoading, setAnalysisLoading,
        isCalendarListLoading,
        calendarList,
        dataBuildAScenarioData,
        hotSerBuildAScenarioData,
        setCreativeProposal,
        creativeProposal,
        getCalendarListData,
        hotSerBuildAScenarioLoading,
        handleHotSerBuildAScenario,
        handleHotSerBuildAScenarioCancel,
        dataBuildAScenarioLoading,
        handleDataBuildAScenario,
        handleDataBuildAScenarioCancel,
        activeFrom,
        setActiveFrom,
        dayInfoData,
        dayInfoLoading,
        handleDayInfo,
        isPlanInfo, setIsPlanInfo,
        withPictures, setWithPictures,
        bandageGenerateAnImageData,
        bandageGenerateInfoLoading,
        isSelectTaskImageLists, setIsSelectTaskImageLists,
        handleBandageGenerateAnImage,
        handleHotProgrammeImagesCancel,
        handleHotProgrammeImages
    }
};

export default marketingCalendar;
